/* eslint-disable @next/next/no-html-link-for-pages */
import React from "react";
import { ChevronRightIcon } from "@heroicons/react/solid";
import { Paragraph } from "../components/common/Paragraph";
import Link from "next/link";
import { NextSeo } from "next-seo";

const PrivacyPage = () => {
  return (
    <>
      <NextSeo noindex={true} />
      <div className="min-h-screen py-12 mx-auto bg-black max-w-7xl">
        <nav className="hidden px-4 md:flex" aria-label="Breadcrumb">
          <ol role="list" className="flex items-center space-x-4">
            <li>
              <div className="font-medium text-gray-300 text-md hover:text-gray-500">
                <a href="/">Home</a>
              </div>
            </li>
            <li>
              <div className="flex items-center">
                <ChevronRightIcon
                  className="flex-shrink-0 w-5 h-5 text-gray-400"
                  aria-hidden="true"
                />
                <div className="ml-4 font-medium text-gray-300 text-md hover:text-gray-500">
                  <Link href="/terms-and-conditions" passHref>
                    Terms and Conditions
                  </Link>
                </div>
              </div>
            </li>
          </ol>
        </nav>
        <div className="px-4 bg-black">
          <div className="py-8">
            <h1 className="text-2xl font-bold leading-7 text-white md:text-4xl sm:truncate">
              Terms and Conditions
            </h1>
          </div>
          <SectionHeading>Foreword and Preamble</SectionHeading>
          <Paragraph>
            This document named as Terms And Conditions of the services
            providing by Maxima includes provisions governing the services and
            establishes legal frames for the services providing by Beyond Zero
            Technology Group Limited as the “Provider” or “Company” at the
            further part of this terms and conditions. The general rules
            introduced in this document establishes the rights and obligations
            of the Provider and the Users. The terms and conditions applies to
            all services, worldwide until the Provider decided, at his own
            discretion to change the provisions of this document.
          </Paragraph>
          <Paragraph>
            We deeply believe, that you act in the best faith, and your
            activities involved with use of Maxima do not violate any rights of
            any person or company. As a professional and innovative Company, we
            do everything to ensure that our products are not used to violate or
            disturb any rights of any business entity or a person. We believe,
            that you act fair and your main goal is to freely create and express
            yourself through your creations and protect your intellectual
            property rights with the possibilities provided by NFT and
            blockchain technology. Hereinafter we grant you license for usage of
            our software and technology but we expect, that your activities
            involved with our technology will follow our rules and standards.
          </Paragraph>
          <SectionHeading>Interpretation</SectionHeading>
          <Paragraph>
            The words of which the initial letter is capitalized have meanings
            defined under the following conditions. The following definitions
            shall have the same meaning regardless of whether they appear in
            singular or in plural.
          </Paragraph>
          <SectionHeading>Definitions</SectionHeading>
          <Paragraph>
            PROVIDER – Beyond Zero Technology Group Limited, Flexi-Space,
            220-221, Smart-Space 3F, Units 908-915, Level 9, Cyberport 3, Core
            F, 100 Cyberport Road, Hong Kong
          </Paragraph>
          <Paragraph>
            USER – a person (physical or legal) using the services provided by
            Provider according to the provisions of the terms and conditions.
          </Paragraph>
          <Paragraph>
            PHYSICAL PERSON – a person who is legally permitted to enter into
            contractual relationships and, typically the age of 18 years.
          </Paragraph>
          <Paragraph>
            LEGAL PERSON – a legal entity established under the provisions of
            the law, legally permitted to act on his behalf on the market,
            especially to enter into contractual relations.
          </Paragraph>
          <Paragraph>
            SERVICES – all services provided by the Provider to the Users under
            the provisions of this terms and conditions.
          </Paragraph>
          <Paragraph>
            WEBSITE – the internet domain, design and the source code of the
            website https://maxima.horse or https://marketplace.maxima.horse the
            unique internet address of the Provider, used by Provider to offer a
            services to the Users.
          </Paragraph>
          <Paragraph>
            APPLICABLE LAW – the law of the state (country) which applies to the
            legal relationships between Provider and User.
          </Paragraph>
          <Paragraph>
            NFT – Non Fungible Token. The technology based on blockchain, which
            allows you to sign and protect your intellectual property rights on
            the modern way. Our NFT allows you to sign a digital file and create
            your own NFT token.
          </Paragraph>
          <Paragraph>
            WARRANTY – the right of the User to receive the full quality product
            when the product provided by Us was faulty. Although we keep the
            highest standards of our services, we know that sometimes strange
            situation can just occur, and you, as a costumer, fully protected by
            the regulations of civil law, may be entitled to claim a new thing
            free from any failures or, if we fail to provide you with the full
            quality product, to receive your money back. Under the applicable
            law, we are obliged to repay your money if the physical thing is
            faulty and we fail to provide you fully quality product. Note that
            according to these terms and conditions, we can only pay back to you
            the price of the physical thing, not the worth of NFT token.
          </Paragraph>
          <Paragraph>
            PAYMENTS – all transfers of assets, made with the fiat (fiduciary
            currencies) or with the cryptocurrencies, under the provisions of
            this terms and conditions. According to the provisions of these
            Terms and Conditions, all payments for the services offered by
            Provider are made only in NFT tokens.
          </Paragraph>
          <Paragraph>
            THIRD PARTY RIGHTS – the rights belonging to the third party, like
            copyrights, trademarks, industrial design rights, trade dresses or
            any other intellectual property rights, protected by the law.
          </Paragraph>
          <Paragraph>
            LIMITATIONS OF LIABILITY – the provisions that limits the liability
            of the Provider, especially applied to the situations of the
            violation of third party rights made by the User. Thus Provider does
            not accept any legal liability for the activities undertaken by the
            Users.
          </Paragraph>
          <Paragraph>
            VERIFICATION OF IDENTITY – procedures established by the Company to
            ensure that you use your own identity during the process of creation
            of the NFT.
          </Paragraph>
          <Paragraph>
            YOU - means the individual accessing or using the Service, or the
            company, or other legal entity on behalf of which such individual is
            accessing or using the Service, as applicable.
          </Paragraph>
          <SectionHeading>Acknowledgment</SectionHeading>
          <Paragraph>
            These are the Terms and Conditions governing the use of this Service
            and the agreement that operates between You and the Company. These
            Terms and Conditions set out the rights and obligations of all users
            regarding the use of the Service.
          </Paragraph>
          <Paragraph>
            Your access to and use of the Service is conditioned on Your
            acceptance of and compliance with these Terms and Conditions. These
            Terms and Conditions apply to all visitors, users and others who
            access or use the Service.
          </Paragraph>
          <Paragraph>
            By accessing or using the Service You agree to be bound by these
            Terms and Conditions. If You disagree with any part of these Terms
            and Conditions then You may not access the Service.
          </Paragraph>
          <Paragraph>
            You represent that you are over the age of 18. The Company does not
            permit those under 18 to use the Service.
          </Paragraph>
          <Paragraph>
            Your access to and use of the Service is also conditioned on Your
            acceptance of and compliance with the Privacy Policy of the Company.
            Our Privacy Policy describes Our policies and procedures on the
            collection, use and disclosure of Your personal information when You
            use the Application or the Website and tells You about Your privacy
            rights and how the law protects You. Please read Our Privacy Policy
            carefully before using Our Service.
          </Paragraph>
          <SectionHeading>Services</SectionHeading>
          <Paragraph>
            User, according to the provisions of these terms and conditions is
            entitled to use and enjoy the services provided by the Provider
            through the Website.
          </Paragraph>
          <Paragraph>
            User accepts all provisions of this terms and conditions and other
            regulations which applies to the User e. g. Privacy Policy and other
            documents governing the terms of using of our services.
          </Paragraph>
          <Paragraph>
            Maxima owns all intellectual property and other rights, title and
            interest in and to its site and service (except for user-provided
            content). Your use of the site and service does not grant you any
            right, title or interest to these properties, except as follows.
            Maxima grants you a limited, revocable license to access and use the
            site and service for its intended purpose: the provision of an
            online, on-demand, customizable NFT Items generator. You may only
            use the site and service according to Maxima terms, rules, and
            guidelines found on its site, and Maxima may revoke this license and
            limit your access to the site and service.
          </Paragraph>
          <SectionHeading>Limitation of Liability</SectionHeading>
          <Paragraph>
            You use Maxima site and service at your own risk. Maxima provides
            its site and service without any express or implied warranties.
            Maxima is not responsible for the actions, content, information, or
            data of third parties. You release us, our directors, officers,
            employees, and agents from any claims and damages, known and
            unknown, arising out of or in any way connected with any claim you
            have against Maxima or any related third parties.
          </Paragraph>
          <SectionHeading>Intellectual Property</SectionHeading>
          <Paragraph>
            The Service and its original content (excluding Content provided by
            You or other users), features and functionality are and will remain
            the exclusive property of the Company and its licensors. The Service
            is protected by copyright, trademark, and other laws of both the
            Country and foreign countries. Our trademarks and trade dress may
            not be used in connection with any product or service without the
            prior written consent of the Company.
          </Paragraph>
          <SectionHeading>Disclaimers</SectionHeading>
          <Paragraph>
            Maxima provides the site and service on an &quot;as is&quot; and
            &quot;as available&quot; basis. Maxima does not represent or warrant
            that the site and service or its use:
          </Paragraph>
          <Paragraph>
            A{")"} will be uninterrupted, timely, safe, or secure,
          </Paragraph>
          <Paragraph>
            B{")"} will be free of inaccuracies, errors, or vulnerabilities,
          </Paragraph>
          <Paragraph>
            C{")"} will meet your expectations or requirements, or
          </Paragraph>
          <Paragraph>
            D{")"} will operate in the configuration or with the hardware or
            software you use. Maxima hereby disclaims any and all express or
            implied warranties, including without limitation, warranties of
            fitness for a particular purpose, merchantability, and
            non-infringement to the fullest extent of the law, except to the
            extent that this agreement provides otherwise.
          </Paragraph>
          <Paragraph>
            You agree that Maxima has no responsibility for any damages suffered
            by you in connection with the site and service, and that use of the
            site and service, including all content, data or software
            distributed by, downloaded, or accessed from or through the site and
            service, is at your sole risk. You understand and agree that you
            will be solely responsible for any damage to you, your business or
            your computer system or any loss of data that results from your
            actions and your use of the site and service.
          </Paragraph>
          <Paragraph>
            Maxima collects and uses your information according to its privacy
            policy. You acknowledge that you are responsible for the securing
            your own information, keeping your sensitive information
            confidential, and taking responsibility for actions taken in
            connection with your user account.
          </Paragraph>
          <SectionHeading>Data Protection</SectionHeading>
          <Paragraph>
            Maxima does not control or endorse in any respect any information,
            products, or services offered by third parties through the site and
            service and is not responsible for any possible representations and
            warranties these third parties may make.
          </Paragraph>
          <SectionHeading>Termination of Access</SectionHeading>
          <Paragraph>
            Maxima may refuse to provide its site and service to you, in full or
            in part, effective immediately and without notice, for any reason or
            no reason, but especially if Maxima believes that you (or any others
            whom Maxima believes that you act in concert with) have violated or
            will violate any laws, rights, or term (or the spirit of any term)
            of thus document or if Maxima believes in its sole discretion that
            your use of the site and service may create any risk (including any
            legal risk) for Maxima or it users. Limitation of access may include
            removal or modification of content that you have uploaded or
            otherwise sent to or through the site and service.
          </Paragraph>
          <SectionHeading>United States Legal Compliance</SectionHeading>
          <Paragraph>
            You represent and warrant that (i) You are not located in a country
            that is subject to the United States government embargo, or that has
            been designated by the United States government as a &quot;terrorist
            supporting&quot; country, and (ii) You are not listed on any United
            States government list of prohibited or restricted parties.
          </Paragraph>
          <SectionHeading>Severability</SectionHeading>
          <Paragraph>
            If any provision of these Terms is held to be unenforceable or
            invalid, such provision will be changed and interpreted to
            accomplish the objectives of such provision to the greatest extent
            possible under applicable law and the remaining provisions will
            continue in full force and effect.
          </Paragraph>
          <SectionHeading>Survival</SectionHeading>
          <Paragraph>
            If any of provisions aforementioned in these Terms of Service are to
            be found void, invalid, unenforceable or illegal by a court of law,
            validity and enforceability of other provisions shall not be
            affected in any way. If any provisions are to be declared
            unenforceable, you agree to an amendment made by Maxima to provide
            for the enforcement of those provisions to the fullest extent
            permitted by applicable law.
          </Paragraph>
          <SectionHeading>Changes to These Terms and Conditions</SectionHeading>
          <Paragraph>
            We reserve the right, at Our sole discretion, to modify or replace
            these Terms at any time. If a revision is material We will make
            reasonable efforts to provide at least 30 days&apos; notice prior to
            any new terms taking effect. What constitutes a material change will
            be determined at Our sole discretion.
          </Paragraph>
          <Paragraph>
            By continuing to access or use Our Service after those revisions
            become effective, You agree to be bound by the revised terms. If You
            do not agree to the new terms, in whole or in part, please stop
            using the website and the Service.
          </Paragraph>
          <SectionHeading>Disputes Resolution</SectionHeading>
          <Paragraph>
            If You have any concern or dispute about the Service, You agree to
            first try to resolve the dispute informally by contacting the
            Company.
          </Paragraph>
          <SectionHeading>Entire Agreement</SectionHeading>
          <Paragraph>
            These Terms of Service, any legal notices and disclaimers issued on
            this Website, constitute an entire agreement between you and Maxima
            in relation to your use of this.
          </Paragraph>
          <SectionHeading>Contact Us</SectionHeading>
          <Paragraph>
            If you have further questions with regards to this Terms and
            Conditions, do not hesitate to contact us at{" "}
            <span className="hover:text-gray-200">
              <Link href="mailto:hello@maxima.horse" passHref>
                hello@maxima.horse
              </Link>
            </span>{" "}
            .
          </Paragraph>
        </div>
      </div>
    </>
  );
};

const SectionHeading: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <h2 className="py-4 text-xl font-bold leading-7 text-gray-100 md:text-2xl sm:truncate">
    {children}
  </h2>
);

export default PrivacyPage;
